module Meevo.Plugins.DrawerManager {
  "use strict";

  export class TipsCollectionSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {

    public drawerTipsCollection: any;
    private isEditing: boolean = false;

    constructor(protected drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
      protected dataService: Components.BaseClasses.IDataService,
      protected modalService: Meevo.Components.Modal.IModalService,
      protected appSettings: Meevo.Components.Common.IAppSettings,
      protected $rootScope: angular.IRootScopeService,
      protected $scope: angular.IScope,
      private $translate: angular.translate.ITranslateService,
      private $filter: angular.IFilterService) {
      super(DrawerManager.DrawerManagerSectionTypeEnum.TipsCollection, drawerManagerContext, "tipsCollection", false, true);
    }

    reset() {
    }

    initialize(drawerSessionId: string) {
      this.getTipsCollection(drawerSessionId);
      this.isEditing = true;
    }

    close() {
      this.context.closeSection();
    }

    getTipsCollection(drawerSessionId: string) {
      // initialized paged result
      this.drawerTipsCollection = new Meevo.Components.BaseClasses.PagedResults(this.dataService, `drawer/${drawerSessionId}/tipscollection`);
      // initialized request
      let request = {
        pageNumber: 0,
        itemsPerPage: 25
      }
      // fetch data
      this.drawerTipsCollection.clearSearch();
      this.drawerTipsCollection.initSearch(request);
    }

    get totalTipsAmount(): number {
      return this.drawerManagerContext.selectedDrawer.drawerSession.summary.totalTip;
    }
  }
}
